import { useState } from 'react';

const CORE_API = import.meta.env.VITE_CORE_API_URL || '';

export default function NominateTeacher() {
  const [submitting, setSubmitting] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState('');

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setErr('');
    setOk(false);
    setSubmitting(true);
    const data = Object.fromEntries(new FormData(e.currentTarget));
    const res = await fetch(`${CORE_API}/api/v1/nominations/teacher`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(data),
    });
    setSubmitting(false);
    if (!res.ok) {
      const raw = await res.json().catch(() => ({}));
      const msg = typeof raw?.error === 'string' ? raw.error : raw?.error?.message || 'Failed to submit';
      setErr(msg);
      return;
    }
    setOk(true);
    e.currentTarget.reset();
  }

  return (
    <div className="max-w-2xl mx-auto py-10">
      <h1 className="text-3xl font-bold mb-4">Nominate a Teacher</h1>
      <p className="mb-6 text-cocoa/80">
        Tell us who should be featured for support. We&apos;ll email them with your nomination and an invite to confirm their
        classroom.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input name="nominator_name" className="input w-full" placeholder="Your name" required />
        <input
          name="nominator_email"
          type="email"
          className="input w-full"
          placeholder="Your email"
          required
        />
        <input name="teacher_name" className="input w-full" placeholder="Teacher’s name" required />
        <input
          name="teacher_email"
          type="email"
          className="input w-full"
          placeholder="Teacher’s email"
          required
        />
        <input name="school" className="input w-full" placeholder="School" required />
        <textarea
          name="reason"
          className="textarea w-full"
          placeholder="Why are you nominating them? (optional)"
        />
        <button disabled={submitting} className="btn btn-primary">
          {submitting ? 'Submitting…' : 'Submit nomination'}
        </button>
      </form>

      {ok && (
        <div className="mt-4 rounded-xl border border-mint/40 bg-mint/20 p-4 text-sm text-green-700">
          Thanks for nominating a teacher! We&apos;ll email them right away with your note and a link to confirm their
          classroom for the pool.
        </div>
      )}
      {err && <div className="mt-4 text-red-700">{err}</div>}
    </div>
  );
}
